import './health-provider-feature-list-item.scss';

import { useMemo } from 'react';

import { useHealthProviderFeatureValues } from '../../../data/data/features/use-health-provider-feature-values';
import { HealthProviderFeatureItemDataFragment } from '../../../data/types/api/graphql';
import { makeKeyDownHandler } from '../../../data/utils/make-key-down-handler';
import { CustomFormattedMessage } from '../../../elements/intl/custom-formatted-message';

type HealthProviderFeatureListItemProps = {
  feature: HealthProviderFeatureItemDataFragment;
  onClick?: (value: HealthProviderFeatureItemDataFragment) => void;
};

export function HealthProviderFeatureListItem({
  onClick,
  feature,
}: HealthProviderFeatureListItemProps) {
  const { data: healthProviderFeatures } = useHealthProviderFeatureValues();

  const features = healthProviderFeatures.map(f => ({
    title: f.title,
    key: f.key,
    value: feature.appFeatures.includes(f.key) ?? false,
  }));

  const attributes = useMemo(() => {
    if (onClick) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: () => onClick(feature),
        onKeyDown: makeKeyDownHandler(() => onClick(feature)),
      };
    }

    return {};
  }, [feature, onClick]);

  return (
    <div {...attributes} className="health-provider-feature-list-item">
      <div className="health-provider-translation-list-item__content">
        <h3>{feature.availabilityStatus}</h3>
      </div>
      {features.map(f => (
        <div
          key={f.key}
          className="health-provider-translation-list-item__content"
        >
          <h3>{f.title}</h3>
          <p className={f.value ? 'active' : ''}>
            <CustomFormattedMessage id={f.value ? 'common.on' : 'common.off'} />
          </p>
        </div>
      ))}
    </div>
  );
}
